import * as React from 'react'
import Typography from '@mui/material/Typography'

const VendorsPageTitle: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <Typography sx={{ fontSize: 32, fontWeight: 'fontWeightLight' }}>{children}</Typography>
}

export default VendorsPageTitle
